import { Params } from '@angular/router';

import { Role, Type } from '@personal-area/global/users/models';

export const paramsKey = 'fbs:register.params'; // ключ для хранения параметров запроса

export class RegisterParams implements Params {
  tariff: string;
  account: string;
  type: Type;
  role: Role;
  lang: string;
  currency: string;
  name: string;
  email: string;
  socialId: string;
  socialProvider: string;
  landingRegistration: {
    cookieName: string;
    cookieSalt: string;
  };
  error = false;
}
